import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { resolveImage } from "@/lib/api";

const INJECTABLE_IMG = "/injectable.webp";
const ORAL_IMG = "/oral.webp";


const CategoryTile = ({ id, img, name, delay, bright }) => {
  const scrollTo = () => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <motion.button
      onClick={scrollTo}
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, delay, ease: [0.22, 1, 0.36, 1] }}
      className="group relative overflow-hidden rounded-xl border border-[#29FF87]/25 glow-border bg-[#0B120B] min-h-[42vh] md:min-h-[72vh]"
      data-testid={`category-tile-${id}`}
    >
      <img
        src={resolveImage(img)}
        alt={name}
        className={
          bright
            ? "absolute inset-0 w-full h-full object-cover object-center opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700"
            : "absolute inset-0 w-full h-full object-cover opacity-45 group-hover:opacity-70 group-hover:scale-105 transition-all duration-700"
        }
      />
      {bright ? (
        <>
          <div className="absolute inset-x-0 bottom-0 h-2/5 bg-gradient-to-t from-[#050805] via-[#050805]/70 to-transparent" />
          <div className="absolute bottom-6 left-0 right-0 z-10 flex flex-col items-center gap-2">
            <h2 className="font-grotesk font-extrabold uppercase tracking-tight glow-green text-5xl md:text-7xl">{name}</h2>
            <span className="inline-flex items-center gap-2 font-body text-[11px] md:text-xs uppercase tracking-[0.3em] text-[#29FF87] opacity-80 group-hover:opacity-100 group-hover:gap-3 transition-all duration-300">
              View collection <ArrowUpRight size={15} />
            </span>
          </div>
        </>
      ) : (
        <>
          <div className="absolute inset-0 bg-gradient-to-t from-[#050805] via-[#050805]/30 to-[#050805]/50" />
          <div className="relative z-10 h-full flex flex-col items-center justify-center gap-4">
            <h2 className="font-grotesk font-extrabold uppercase tracking-tight glow-green text-5xl md:text-7xl">{name}</h2>
            <span className="inline-flex items-center gap-2 font-body text-[11px] md:text-xs uppercase tracking-[0.3em] text-[#29FF87] opacity-80 group-hover:opacity-100 group-hover:gap-3 transition-all duration-300">
              View collection <ArrowUpRight size={15} />
            </span>
          </div>
        </>
      )}
    </motion.button>
  );
};

export const CategoryHero = ({ injectableImg = INJECTABLE_IMG, oralImg = ORAL_IMG }) => {
  return (
    <section id="top" className="relative w-full bg-grid min-h-[calc(100vh-40px)] flex items-center px-6 md:px-12 py-10 overflow-hidden" data-testid="hero-section">
      <div className="max-w-[1600px] mx-auto w-full grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8">
        <CategoryTile id="injectable" img={injectableImg} name="Injectable" delay={0.3} bright />
        <CategoryTile id="oral" img={oralImg} name="Oral" delay={0.45} bright />
      </div>
    </section>
  );
};
